import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Tag } from 'primereact/tag';
import {
  fetchChainNetvisorSettings as _fetchChainNetvisorSettings,
  updateChainNetvisorSettings as _updateChainNetvisorSettings,
  testNetvisorConnection as _testNetvisorConnection,
} from '../../../actions/chainActions';
import { T, cardStyle, inputStyle, inputLabelStyle } from './chainSettingsV2Styles';

class SettingsChainNetvisorV2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        customer_id: '',
        partner_id: '',
        organization_id: '',
        customer_key: '',
        partner_key: '',
        api_base_url: 'https://integration.netvisor.fi',
        is_active: true,
      },
      hasChanges: false,
      testingConnection: false,
      testResult: null,
    };
  }

  componentDidMount() {
    var chainId = this.props.chainId;
    if (chainId) {
      this.props.fetchChainNetvisorSettings(chainId);
    }
  }

  componentDidUpdate(prevProps) {
    var settings = this.props.chainNetvisorSettings;
    var prevSettings = prevProps.chainNetvisorSettings;

    if (settings && settings !== prevSettings) {
      this.initializeForm(settings);
    }

    if (this.props.chainId && this.props.chainId !== prevProps.chainId) {
      this.props.fetchChainNetvisorSettings(this.props.chainId);
    }

    // Handle test connection result
    var testResult = this.props.chainNetvisorTestResult;
    if (testResult && testResult !== prevProps.chainNetvisorTestResult) {
      this.setState({ testingConnection: false, testResult: testResult });
    }
  }

  initializeForm = function (settings) {
    this.setState({
      formData: {
        customer_id: settings.customer_id || '',
        partner_id: settings.partner_id || '',
        organization_id: settings.organization_id || '',
        customer_key: '',
        partner_key: '',
        api_base_url: settings.api_base_url || 'https://integration.netvisor.fi',
        is_active: settings.is_active !== undefined ? settings.is_active : true,
      },
      hasChanges: false,
      testResult: null,
    });
  }.bind(this);

  updateFormState = function (changedObject) {
    var formData = this.state.formData;
    this.setState({
      formData: { ...formData, [changedObject.target]: changedObject.value },
      hasChanges: true,
    });
  }.bind(this);

  submitForm = function () {
    var settings = this.props.chainNetvisorSettings;
    if (settings && settings.id) {
      var data = { ...this.state.formData };
      // Don't send empty key fields (means "don't change")
      if (!data.customer_key) { delete data.customer_key; }
      if (!data.partner_key) { delete data.partner_key; }
      this.props.updateChainNetvisorSettings(settings.id, data);
      this.setState({ hasChanges: false });
    }
  }.bind(this);

  testConnection = function () {
    var chainId = this.props.chainId;
    this.setState({ testingConnection: true, testResult: null });
    this.props.testNetvisorConnection(chainId);
  }.bind(this);

  render() {
    var t = this.props.t;
    var settings = this.props.chainNetvisorSettings;
    var settingsStatus = this.props.chainNetvisorSettingsStatus;
    var formData = this.state.formData;
    var hasChanges = this.state.hasChanges;
    var testResult = this.state.testResult;
    var testingConnection = this.state.testingConnection;
    var isLoading = settingsStatus && settingsStatus.loading;

    if (!settings && isLoading) {
      return (
        <div style={{ ...cardStyle, position: 'relative', minHeight: 200 }}>
          <CBSpinnerFloating color={T.accent} />
        </div>
      );
    }

    return (
      <CBMediaQuery>
        {function (screenSize) {
          return (
            <div style={getStyle(screenSize, styles, 'card')}>
              <div style={getStyle(screenSize, styles, 'header')}>
                <div style={getStyle(screenSize, styles, 'iconBox')}>
                  <i className="pi pi-cloud" style={{ fontSize: 20, color: T.accent }} />
                </div>
                <div>
                  <h2 style={getStyle(screenSize, styles, 'title')}>{t('netvisorConnectionTitle')}</h2>
                  <p style={getStyle(screenSize, styles, 'description')}>{t('netvisorConnectionDescription')}</p>
                </div>
              </div>

              {isLoading && <CBSpinnerFloating color={T.accent} />}

              {/* Sync status display */}
              {settings && settings.last_sync_at && (
                <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Tag
                    severity={settings.last_sync_status === 'ok' ? 'success' : 'danger'}
                    value={settings.last_sync_status === 'ok' ? t('connectionOk') : t('connectionError')}
                  />
                  <span style={{ color: T.textMuted, fontSize: 12 }}>
                    {t('lastSync')}: {new Date(settings.last_sync_at).toLocaleString('fi-FI')}
                  </span>
                </div>
              )}

              <div style={getStyle(screenSize, styles, 'formContainer')}>
                <CBInputField
                  name="customer_id"
                  inputStyle={inputStyle}
                  value={formData.customer_id}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorCustomerId')}
                  labelTextStyle={inputLabelStyle}
                />

                <CBInputField
                  name="partner_id"
                  inputStyle={inputStyle}
                  value={formData.partner_id}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorPartnerId')}
                  labelTextStyle={inputLabelStyle}
                />

                <CBInputField
                  name="organization_id"
                  inputStyle={inputStyle}
                  value={formData.organization_id}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorOrganizationId')}
                  labelTextStyle={inputLabelStyle}
                />

                <CBInputField
                  name="customer_key"
                  inputStyle={inputStyle}
                  value={formData.customer_key}
                  placeholder={settings && settings.customer_key ? settings.customer_key : ''}
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorCustomerKey')}
                  labelTextStyle={inputLabelStyle}
                  type="password"
                />

                <CBInputField
                  name="partner_key"
                  inputStyle={inputStyle}
                  value={formData.partner_key}
                  placeholder={settings && settings.partner_key ? settings.partner_key : ''}
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorPartnerKey')}
                  labelTextStyle={inputLabelStyle}
                  type="password"
                />

                <CBInputField
                  name="api_base_url"
                  inputStyle={inputStyle}
                  value={formData.api_base_url}
                  placeholder="https://integration.netvisor.fi"
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorApiBaseUrl')}
                  labelTextStyle={inputLabelStyle}
                />

                <div style={{ marginBottom: 16 }}>
                  <label style={inputLabelStyle}>{t('netvisorActive')}</label>
                  <div style={{ marginTop: 6 }}>
                    <InputSwitch
                      checked={formData.is_active}
                      onChange={function (e) {
                        this.setState({
                          formData: { ...this.state.formData, is_active: e.value },
                          hasChanges: true,
                        });
                      }.bind(this)}
                    />
                  </div>
                </div>

                {/* Test result */}
                {testResult && (
                  <div style={{
                    padding: '10px 14px',
                    borderRadius: 6,
                    marginBottom: 16,
                    backgroundColor: testResult.success ? 'rgba(46, 204, 113, 0.15)' : 'rgba(231, 76, 60, 0.15)',
                    color: testResult.success ? '#2ecc71' : '#e74c3c',
                    fontSize: 13,
                  }}>
                    {testResult.success ? t('connectionSuccess') : t('connectionFailed')}
                    {testResult.message && ': ' + testResult.message}
                  </div>
                )}

                <div style={{ display: 'flex', gap: 12, marginTop: 28 }}>
                  <Button
                    onClick={this.submitForm}
                    label={t('saveChanges')}
                    disabled={isLoading || !hasChanges}
                    style={{
                      backgroundColor: hasChanges ? T.accent : 'rgba(255,255,255,0.1)',
                      border: 'none',
                      color: hasChanges ? '#0077b0' : T.textMuted,
                      fontWeight: 600,
                      opacity: (!hasChanges || isLoading) ? 0.5 : 1,
                    }}
                  />
                  <Button
                    onClick={this.testConnection}
                    label={testingConnection ? '...' : t('testConnection')}
                    disabled={testingConnection}
                    className="p-button-outlined"
                    style={{
                      borderColor: T.accent,
                      color: T.accent,
                      fontWeight: 600,
                    }}
                  />
                </div>
              </div>
            </div>
          );
        }.bind(this)}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    card: { ...cardStyle, position: 'relative' },
    header: { display: 'flex', alignItems: 'center', gap: 16, marginBottom: 28 },
    iconBox: {
      width: 48, height: 48, borderRadius: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    },
    title: { color: T.textPrimary, fontSize: 18, fontWeight: 600, margin: 0 },
    description: { color: T.textSecondary, fontSize: 13, margin: '4px 0 0 0' },
    formContainer: { maxWidth: '100%' },
  },
  medium: {
    card: { ...cardStyle, padding: 16 },
  },
};

function mapStateToProps(state) {
  return {
    chainNetvisorSettings: state.chain.chainNetvisorSettings,
    chainNetvisorSettingsStatus: state.chain.chainNetvisorSettingsStatus,
    chainNetvisorTestResult: state.chain.chainNetvisorTestResult,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChainNetvisorSettings: _fetchChainNetvisorSettings,
    updateChainNetvisorSettings: _updateChainNetvisorSettings,
    testNetvisorConnection: _testNetvisorConnection,
  },
)(translate('ChainSettingsView')(SettingsChainNetvisorV2));
